import React from "react";
import { getVideoPlatformRows } from "../../lib/platformStatus";

export const CHECKLIST = [
  ["assets", "Assets"],
  ["metadata", "Metadata"],
  ["cast_legal", "Cast / Legal"],
  ["edit", "Edit"],
  ["destinations", "Destinations / Scheduled posts"],
  ["published", "Published"],
  ["performance", "Performance"],
];
const STATES = [["not_started", "Not started"], ["in_progress", "In progress"], ["complete", "Complete"], ["blocked", "Blocked"]];
const COLORS = { not_started: "text-zinc-400 border-zinc-700", in_progress: "text-amber-300 border-amber-500/40", complete: "text-emerald-300 border-emerald-500/40", blocked: "text-red-300 border-red-500/40" };

// Suggested status when nothing has been set manually yet (same signals the old grid checklist used).
export function inferChecklist(v) {
  const rows = getVideoPlatformRows(v);
  const done = {
    assets: Boolean(v.mux_playback_id || v.scene_photos?.length || v.trailer_mux_playback_id || v.extra_videos?.length || v.linked_photos?.length),
    metadata: Boolean(v.title && (v.free_description || v.description || v.tags?.length || v.shoot_date)),
    cast_legal: Boolean((v.cast_crm_ids || []).length && ((v.legal_docs || []).length || v.legal_notes || v.studio_contract_url)),
    edit: Boolean(v.edit_status && v.edit_status !== "pending"),
    destinations: rows.length > 0 || (Array.isArray(v.scheduled_posts) && v.scheduled_posts.length > 0),
    published: rows.some((r) => ["published", "re_published", "live_on_subs"].includes(r.status)),
    performance: Boolean(v.performance || v.performance_metrics),
  };
  return Object.fromEntries(Object.entries(done).map(([k, ok]) => [k, ok ? "complete" : "not_started"]));
}

export default function ChecklistTab({ record, setField }) {
  const stored = record.production_checklist || {};
  const inferred = inferChecklist(record);
  return (
    <div className="space-y-2">
      <p className="text-xs text-zinc-500">Track production progress. Items without a manual status show a suggestion from the video data.</p>
      {CHECKLIST.map(([key, label]) => {
        const value = stored[key] || inferred[key];
        return (
          <div key={key} className="flex items-center justify-between gap-3 rounded-lg border border-zinc-800 bg-black/40 px-3 py-2.5" data-testid={`checklist-${key}`}>
            <div>
              <div className="text-sm text-white">{label}</div>
              {!stored[key] && <div className="text-[10px] text-zinc-500">Suggested</div>}
            </div>
            <select aria-label={`${label} status`} value={value} onChange={(e) => setField("production_checklist", { ...stored, [key]: e.target.value })}
              className={`bg-zinc-900 border rounded-lg px-2 py-1.5 text-sm ${COLORS[value]}`}>
              {STATES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
        );
      })}
    </div>
  );
}
